import React from 'react';
import { Typography } from "@mui/material";
const Messages = () => {
    return(
        <Typography variant="h3">The Messages Page</Typography>
    )
}

export default Messages;